import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './navigation/navigation.component';
import { MaterialModule } from '../shared/material.module';
import { CustomSnackbarComponent } from '../core/customcomponent/custom-snackbar.component'
import { SuccessSnackbarComponent } from '../core/customcomponent/success-snackbar.component'
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { NotificationbannerComponent } from './notificationbanner/notificationbanner.component';
import { PendingNotificationComponent } from './notificationbanner/pending-notification/pending-notification.component';
import { AddEditNotificationComponent } from './notificationbanner/add-edit-notification/add-edit-notification.component';
import { ApplicationSettingsComponent } from './application-settings/application-settings.component';
import { TooltipModule } from 'ng2-tooltip-directive';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    CustomSnackbarComponent,
    SuccessSnackbarComponent,
    NotificationbannerComponent,
    PendingNotificationComponent,
    AddEditNotificationComponent, 
    ApplicationSettingsComponent


  ],
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    CustomSnackbarComponent,
    SuccessSnackbarComponent,
    FormsModule,
    ReactiveFormsModule
    
  ]
})
export class CoreModule { }
